<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {

  name: 'Empty',

  data () {
    return {}
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/layouts/EmptyLayout.vue